import React from 'react';
import { useT } from '../i18n/LanguageContext';

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useT();

  const btn = (l, label) => (
    <button
      onClick={() => setLang(l)}
      className={`px-2.5 py-1 rounded-full text-xs font-semibold transition-colors ${
        lang === l
          ? 'bg-[#4dbfae] text-white'
          : 'text-white/70 hover:text-white'
      }`}
      aria-label={`Switch to ${label}`}
    >
      {label}
    </button>
  );

  const btnLight = (l, label) => (
    <button
      onClick={() => setLang(l)}
      className={`px-2.5 py-1 rounded-full text-xs font-semibold transition-colors ${
        lang === l
          ? 'bg-[#4dbfae] text-white'
          : 'text-[#5b6469] hover:text-[#1a2851]'
      }`}
      aria-label={`Switch to ${label}`}
    >
      {label}
    </button>
  );

  const B = compact ? btnLight : btn;
  return (
    <div className={`inline-flex items-center gap-1 rounded-full ${compact ? 'bg-[#f2fbf9]' : 'bg-white/10'} p-1`}>
      {B('en', 'EN')}
      {B('pt', 'PT')}
    </div>
  );
}
